export default {
  Model: {
    ID: 'id',
    UUID: 'uuid',
    IS_HIGH_PRIORITY: 'isHighPriority',
    COMPLETED: 'completed',
    COMPLETED_AT: 'completedAt',
    PARENT_UUID: 'parentUuid',
    BODY: 'body',
    BODY_RAW_TEXT: 'bodyRawText',
    VIDEO: 'video',
    ATTACHMENTS: 'attachments',
    SHOW_PREVIEW: 'showPreview',
    DUE_BY: 'dueBy',
    RECURRING_WORKSPACE_ITEM: 'recurringWorkspaceItem',
    ASSIGNMENT_AVATAR: 'assignmentAvatar',
    WORKSPACE_ID: 'workspaceId',
    WORKSPACE_NAME: 'workspaceName',
    WORKSPACE_PATH: 'workspacePath',
    ASSIGNEE: 'assignee',
    HISTORY: 'history',
    ASANA_DATA: 'asanaData',
    TASK_ID: 'taskId',
    URL: 'url',
    ITEM_TYPE: 'itemType',
    GOAL_SLUG: 'goalSlug',
    POSITION: 'position',
    POSITION_FOR_GOAL_DETAIL_PAGE: 'positionForGoalDetailPage',
    PARENT_ID: 'parentId',
    PARENT_IS_SECTION: 'parentIsSection',
    COMMENTS_COUNT: 'commentsCount',
    CREATED_AT: 'createdAt',
    UPDATED_AT: 'updatedAt',
    GOAL_ID: 'goalId',
    IS_SECTION: 'isSection',
    ASSOCIATED_MEETING_ITEM_ID: 'associatedMeetingItemId',
    ASSOCIATED_MEETING_ITEM_UUID: 'associatedMeetingItemUuid',
    USER_ID: 'userId',
    // afterUuid is sent across in the to set objects position in the order
    AFTER_UUID: 'afterUuid',
  },
  Actions: {
    FETCH_MEETING_ITEMS_SUCCESS: 'meeting_items/FETCH_MEETING_ITEMS_SUCCESS',
    FETCH_SINGLE_MEETING_ITEMS_SUCCESS: 'meeting_items/FETCH_SINGLE_MEETING_ITEMS_SUCCESS',
    FETCH_GOAL_ACTION_ITEMS_SUCCESS: 'meeting_items/FETCH_GOAL_ACTION_ITEMS_SUCCESS',
    FETCH_WORKSPACE_ACTION_ITEMS_SUCCESS: 'meeting_items/FETCH_WORKSPACE_ACTION_ITEMS_SUCCESS',
    UPDATE_COMPLETE_STATUS_SUCCESS: 'meeting_items/UPDATE_COMPLETE_STATUS_SUCCESS',
    UPDATE_HIGH_PRIORITY_SUCCESS: 'meeting_items/UPDATE_HIGH_PRIORITY_SUCCESS',
    ATTACH_FILE_SUCCESS: 'meeting_items/ATTACH_FILE_SUCCESS',
    DELETE_FILE_SUCCESS: 'meeting_items/DELETE_FILE_SUCCESS',
    DELETE_MEETING_ITEM_SUCCESS: 'meeting_items/DELETE_MEETING_ITEM_SUCCESS',
    UPDATE_SHOW_PREVIEW_SUCCESS: 'meeting_items/UPDATE_SHOW_PREVIEW_SUCCESS',
    UPDATE_DUE_BY_SUCCESS: 'meeting_items/UPDATE_DUE_BY_SUCCESS',
    UPDATE_RECURRENCE_SUCCESS: 'meeting_items/UPDATE_RECURRENCE_SUCCESS',
    DELETE_RECURRENCE_SUCCESS: 'meeting_items/DELETE_RECURRENCE_SUCCESS',
    UPDATE_ASSIGNEE_SUCCESS: 'meeting_items/UPDATE_ASSIGNEE_SUCCESS',
    CREATE_ASANA_TASK_SUCCESS: 'meeting_items/CREATE_ASANA_TASK_SUCCESS',
    DISCONNECT_ASANA_TASK_SUCCESS: 'meeting_items/DISCONNECT_ASANA_TASK_SUCCESS',
    UPDATE_ITEM_BODY_SUCCESS: 'meeting_items/UPDATE_ITEM_BODY_SUCCESS',
    UPDATE_ITEM_BODY_IN_REDUX: 'meeting_items/UPDATE_ITEM_BODY_IN_REDUX',
    REMOVE_NESTING_SUCCESS: 'meeting_items/REMOVE_NESTING_SUCCESS',
    CREATE_NEW_MEETING_ITEM_SUCCESS: 'meeting_items/CREATE_NEW_MEETING_ITEM_SUCCESS',
    CREATE_NEW_TEMP_MEETING_ITEM_SUCCESS: 'meeting_items/CREATE_NEW_TEMP_MEETING_ITEM_SUCCESS',
    CLEAR_TEMP_MEETING_ITEM_SUCCESS: 'meeting_items/CLEAR_TEMP_MEETING_ITEM_SUCCESS',
    DELETE_TEMP_MEETING_ITEM_SUCCESS: 'meeting_items/DELETE_TEMP_MEETING_ITEM_SUCCESS',
    UPDATE_PARENT_UUID_SUCCESS: 'meeting_items/UPDATE_PARENT_UUID_SUCCESS',
    REMOVE_NESTING_OF_TEMP_ITEM_SUCCESS: 'meeting_items/REMOVE_NESTING_OF_TEMP_ITEM_SUCCESS',
    NEST_TEMP_ITEM_SUCCESS: 'meeting_items/NEST_TEMP_ITEM_SUCCESS',
    DELETE_TEMP_ITEM_SUCCESS: 'meeting_items/DELETE_TEMP_ITEM_SUCCESS',
    ADD_TO_GOAL_SUCCESS: 'meeting_items/ADD_TO_GOAL_SUCCESS',
    REMOVE_FROM_GOAL_SUCCESS: 'meeting_items/REMOVE_FROM_GOAL_SUCCESS',
    CONVERT_DISCUSSION_TOPIC_AND_ACTION_ITEM: 'meeting_items/CONVERT_DISCUSSION_TOPIC_AND_ACTION_ITEM',
    DUPLICATE_ITEM: 'meeting_items/DUPLICATE_ITEM',
  },
  State: {
    MEETING_ITEMS_BY_ITEM_SLUG: 'MEETING_ITEMS_BY_ITEM_SLUG',
    ACTION_ITEM_IDS_BY_WORKSPACE_SLUG: 'ACTION_ITEM_IDS_BY_WORKSPACE_SLUG',
    DISCUSSION_TOPIC_IDS_BY_WORKSPACE_SLUG: 'DISCUSSION_TOPIC_IDS_BY_WORKSPACE_SLUG',
    ACTION_ITEM_IDS_BY_GOAL_SLUG: 'ACTION_ITEM_IDS_BY_GOAL_SLUG',
    TEMP_ACTION_ITEM_IDS_BY_SLUG: 'TEMP_ACTION_ITEM_IDS_BY_SLUG',
  },
};
